<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 80 80"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path d="M11.48,42a.56.56,0,0,1,.41-.94h3.66v3.38H13.93Z" />
      <path d="M14.86,33.58a.58.58,0,0,1-.15-.38.56.56,0,0,1,.55-.56h3.67V36H17.31Z" />
      <path d="M14.86,50.47a.59.59,0,0,1-.15-.39.55.55,0,0,1,.55-.55h3.67V52.9H17.31Z" />
      <path d="M18.24,25.14a.55.55,0,0,1,.4-.94h3.67v3.37H20.69Z" />
      <rect x="21.46" y="24.19" width="8.61" height="3.38" />
      <path d="M18.24,58.91a.53.53,0,0,1-.16-.38.56.56,0,0,1,.56-.56h3.67v3.38H20.69Z" />
      <rect x="21.46" y="57.97" width="8.61" height="3.38" />
      <rect x="18.63" y="32.64" width="11.45" height="3.38" />
      <rect x="18.08" y="49.53" width="11.99" height="3.38" />
      <rect x="15" y="41.09" width="15.07" height="3.38" />
      <path
        d="M44.44,46.23a4.34,4.34,0,0,1-.7-8.63,4.36,4.36,0,0,1,5,3.58h0A4.35,4.35,0,0,1,48,44.42a4.3,4.3,0,0,1-2.83,1.75A4.25,4.25,0,0,1,44.44,46.23Zm0-6.69a1.72,1.72,0,0,0-.39,0,2.34,2.34,0,1,0,.77,4.62,2.35,2.35,0,0,0,1.93-2.69h0A2.34,2.34,0,0,0,45.81,40,2.37,2.37,0,0,0,44.45,39.54Z"
      />
      <rect
        x="45.21"
        y="34.75"
        width="11.93"
        height="2"
        transform="translate(-10.77 43.5) rotate(-42.07)"
      />
      <rect x="42.34" y="15.19" width="2" height="7.26" />
      <rect
        x="61.21"
        y="23.18"
        width="3.43"
        height="3.38"
        transform="translate(-0.45 48.57) rotate(-42.07)"
      />
      <rect x="38.62" y="11.89" width="9.44" height="3.38" />
      <rect
        x="62.66"
        y="20.61"
        width="3.38"
        height="5.49"
        transform="translate(2.33 52.34) rotate(-45)"
      />
      <path d="M43.34,68.05V64.67a22,22,0,0,0,0-43.91V17.38a25.34,25.34,0,0,1,0,50.67Z" />
      <rect x="42.34" y="18.23" width="2" height="4.22" />
      <rect x="42.23" y="62.98" width="2" height="4.22" />
      <rect
        x="53.42"
        y="60.01"
        width="2"
        height="4.22"
        transform="translate(-23.77 35.54) rotate(-30)"
      />
      <rect
        x="61.63"
        y="51.84"
        width="2"
        height="4.22"
        transform="translate(-15.41 81.22) rotate(-60)"
      />
      <rect x="63.55" y="41.77" width="4.22" height="2" />
      <rect
        x="60.58"
        y="30.58"
        width="4.22"
        height="2"
        transform="translate(-7.39 35.57) rotate(-29.99)"
      />
      <path
        d="M43.41,68.11A25.6,25.6,0,0,1,35.88,67l-.18-.06-1.54-.68,1.36-3.1,1.45.64a22,22,0,1,0-2.64-41L33,19.63A25.35,25.35,0,1,1,43.41,68.11Z"
      />
      <rect
        x="52.41"
        y="22.36"
        width="4.22"
        height="2"
        transform="translate(7.03 58.9) rotate(-60.01)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-is-early-value",
  components: {},
})
export class IconIsEarlyValue extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconIsEarlyValue;
</script>
